import React from 'react';
import styled from '@emotion/styled';
import { ShimmerStyles } from '../../../styles/Shimmer';
import { Css, Responsive, Shimmer, ShimmerPlaceholderText } from '../../../ui';
import {
	Container,
	SWTCardSquircleIcon,
} from './SecurityWaitTimesWidget.styles';
import {
	MainInformation,
	WidgetContent,
	WidgetContentBlock,
	WidgetContentTextShimmer,
	WidgetHeader,
	WidgetTitleShimmer,
} from '../../shared/components/widget/WidgetContainer';
import SecurityIcon from '../../../assets/icons/security.svg';
import { WidgetContentMobileHeaders } from './SecurityWaitTimesWidget';

export default function SecurityWaitTimesWidgetShimmer() {
	const isMobileXL = !!Responsive.useMatchesBreakpoint('mobileXL');
	return (
		<LoadingWidgetContainer>
			<Shimmer>
				<MainInformation>
					<WidgetHeader>
						<WidgetTitleShimmer />
					</WidgetHeader>
					<WidgetContent>
						{isMobileXL && (
							<WidgetContentMobileHeaders>
								<WidgetContentTextShimmer minWidth="31" maxWidth="81" />
								<WidgetContentTextShimmer minWidth="58" maxWidth="81" />
							</WidgetContentMobileHeaders>
						)}
						<WidgetContentBlock>
							<WidgetContentTextShimmer minWidth="35" maxWidth="103" />
							<WidgetContentTextShimmer minWidth="74" maxWidth="103" />
						</WidgetContentBlock>
						<WidgetContentBlock>
							<WidgetContentTextShimmer minWidth="54" maxWidth="136" />
							<WidgetContentTextShimmer minWidth="92" maxWidth="136" />
						</WidgetContentBlock>
						<WidgetContentBlock>
							<WidgetContentTextShimmer minWidth="84" />
							<WidgetContentTextShimmer minWidth="92" />
						</WidgetContentBlock>
					</WidgetContent>
					<WidgetFooterShimmerDesktop height="33" />
					<WidgetFooterShimmer />
				</MainInformation>
			</Shimmer>
			<SWTCardSquircleIcon icon={<SecurityIcon role="presentation" />} />
		</LoadingWidgetContainer>
	);
}

const LoadingWidgetContainer = styled(Container)`
	padding: ${Css.pxToRem(37)} ${Css.pxToRem(40)};
	${MainInformation} {
		width: 100%;
		gap: ${Css.pxToRem(30)};
	}
		${WidgetContent} {
		gap: ${Css.pxToRem(28)};
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		${MainInformation} {
			gap: ${Css.pxToRem(15)};
		}
	}
`;

const WidgetFooterShimmer = styled(ShimmerPlaceholderText)<{ height?: string }>`
	width: 100%;
	height: ${({ height }) => Css.pxToRem(height ? +height : 53)};
	border-radius: 4px;
	background-color: ${ShimmerStyles.BackgroundColor};
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		width: ${Css.pxToRem(156)};
		height: ${Css.pxToRem(14)};
	}
`;

const WidgetFooterShimmerDesktop = styled(WidgetFooterShimmer)`
	display: flex;
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: none;
	}
`;
